import { render, staticRenderFns } from "./VqCheckboxes.vue?vue&type=template&id=74ada6ab&scoped=true&lang=html&"
import script from "./VqCheckboxes.vue?vue&type=script&lang=js&"
export * from "./VqCheckboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ada6ab",
  null
  
)

export default component.exports